/**
 * Geração de PDF e impressão das folhas A4 — mesma técnica do HTML original
 * (html2canvas captura cada folha renderizada + jsPDF monta o A4 multi-página),
 * usando as libs que o ERP já tem (html2canvas + jspdf). Sem CDN.
 */
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";

import { documentoCssJanela } from "./documentoCss";

const SELETOR_FOLHAS = "#rf-print-papers .rf-paper";

/**
 * Captura cada `.rf-paper` e baixa um PDF A4. Folha por folha (controle total
 * das páginas, sem quebras automáticas indesejadas). Folha que extravasa A4 é
 * fatiada em sub-páginas.
 */
export async function baixarPdf(filename = "Lista_Compras.pdf") {
  const papers = Array.from(document.querySelectorAll(SELETOR_FOLHAS));
  if (!papers.length) return;

  const pdf = new jsPDF({ unit: "mm", format: "a4", orientation: "portrait", compress: true });
  const pageW = 210;
  const pageH = 297;

  for (let i = 0; i < papers.length; i += 1) {
    // eslint-disable-next-line no-await-in-loop
    const canvas = await html2canvas(papers[i], {
      scale: 2,
      useCORS: true,
      backgroundColor: "#ffffff",
      logging: false,
    });

    if (i > 0) pdf.addPage();

    const imgData = canvas.toDataURL("image/jpeg", 0.95);
    const imgW = pageW;
    const imgH = (canvas.height / canvas.width) * imgW;

    if (imgH <= pageH + 1) {
      pdf.addImage(imgData, "JPEG", 0, 0, imgW, imgH);
    } else {
      let y = 0;
      let primeira = true;
      while (y < imgH) {
        if (!primeira) pdf.addPage();
        pdf.addImage(imgData, "JPEG", 0, -y, imgW, imgH);
        y += pageH;
        primeira = false;
      }
    }
  }

  pdf.save(filename);
}

/**
 * Imprime as folhas numa JANELA limpa (sem sidebar/topbar do app). Reusa o
 * #rf-print-papers já renderizado (que carrega o <style> embutido), evitando
 * brigar com o @media print do shell e garantindo zero página em branco.
 * Fallback para window.print() se o popup for bloqueado.
 */
export function imprimirAgora() {
  const node = document.getElementById("rf-print-papers");
  if (!node) {
    window.print();
    return;
  }
  const win = window.open("", "_blank", "width=920,height=1040");
  if (!win) {
    window.print();
    return;
  }
  win.document.open();
  win.document.write(
    `<!DOCTYPE html><html lang="pt-br"><head><meta charset="utf-8">` +
    `<title>Lista de Compras</title>` +
    `<style>${documentoCssJanela()}</style>` +
    `</head><body>${node.outerHTML}</body></html>`,
  );
  win.document.close();
  win.focus();
  setTimeout(() => {
    try {
      win.print();
    } catch {
      /* usuário pode imprimir manualmente */
    }
  }, 350);
}
